import React from 'react';
import { Table, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { ThreeDotsIcon } from '../../Icons';
import helpers from '../../../utils/helpers';
import { countryType } from '../../../types';

function LeadScoringVisitsTest(props) {
  const { Column } = Table;

  return (
    <Table
      size="small"
      dataSource={props.visits}
      loading={props.loading}
      rowKey="id"
      scroll={{ x: true }}
      pagination={{
        showTotal: (total, range) => props.intl.formatMessage({ id: 'Common.Paginator.Total' }, { from: range[0], to: range[1], total }),
      }}
    >
      <Column
        title={props.intl.formatMessage({ id: 'Grid.Column.Country' })}
        dataIndex="country"
        key="country"
        className="text-center"
        render={country => (
          (country) && (
            <Tooltip className="hint" placement="top" title={country.name}>
              <div className="text-center" data-label={props.intl.formatMessage({ id: 'Grid.Column.Country' })}>
                {country.iso_3166_2 && <span className={`flag-icon flag-icon-${(country.iso_3166_2).toLowerCase()}`} />}
              </div>
            </ Tooltip>
          )
        )}
      />
      <Column
        title={props.intl.formatMessage({ id: 'Grid.Column.CompanyName' })}
        dataIndex="company"
        key="company_name"
        width={450}
        render={company => (
          <div
            data-label={props.intl.formatMessage({ id: 'Grid.Column.CompanyName' })}
            style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}
          >
            {company.company_name}
          </div>
        )}
      />
      <Column
        title={props.intl.formatMessage({ id: 'Grid.Column.VisitStartTimestamp' })}
        dataIndex="first_action_timestamp"
        key="first_action_timestamp"
        defaultSortOrder="descend"
        sorter={helpers.getSorterString('first_action_timestamp')}
        render={(dateTime) => {
          const tz = moment.tz(dateTime, props.displayTimezone);
          return (
            <div data-label={props.intl.formatMessage({ id: 'Grid.Column.VisitStartTimestamp' })}>
              {dateTime && moment(tz).format(props.displayDateTimeFormat)}
            </div>
          );
        }}
      />
      <Column
        title={props.intl.formatMessage({ id: 'Grid.Column.Duration' })}
        key="visit_duration"
        className="text-center"
        dataIndex="visit_duration"
        sorter={helpers.getSorterNumber('visit_duration')}
        render={item => (
          <div className="text-center" data-label={props.intl.formatMessage({ id: 'Grid.Column.Duration' })}>
            {moment.utc(item * 1000).format('HH:mm:ss')}
          </div>
        )}
      />
      <Column
        title={props.intl.formatMessage({ id: 'Grid.Column.Pages' })}
        key="page_views"
        className="text-center"
        dataIndex="page_views"
        sorter={helpers.getSorterNumber('page_views')}
        render={item => (
          <div className="text-center" data-label={props.intl.formatMessage({ id: 'Grid.Column.Pages' })}>
            {item}
          </div>
        )}
      />
      <Column
        title={props.intl.formatMessage({ id: 'Grid.Column.Actions' })}
        key="details"
        className="text-center"
        fixed="right"
        width={80}
        render={record => (
          <div className="actions" data-label={props.intl.formatMessage({ id: 'Grid.Column.Actions' })}>
            <Tooltip
              className="hint" placement="top"
              title={props.intl.formatMessage({ id: 'Component.Leads.VisitsList.Button.Hint.VisitDetails' })}
            >
              <Link className="action-wrap" target="_blank" to={`/${props.projectId}/companies/${record.company.id}/visits/${record.id}`}>
                <ThreeDotsIcon />
              </Link>
            </Tooltip>
          </div>
        )}
      />
    </Table>
  );
}

LeadScoringVisitsTest.propTypes = {
  projectId: PropTypes.string.isRequired,
  displayTimezone: PropTypes.string.isRequired,
  displayDateTimeFormat: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  visits: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    country: countryType,
    company: PropTypes.shape({
      id: PropTypes.number.isRequired,
      company_name: PropTypes.string.isRequired,
    }).isRequired,
    first_action_timestamp: PropTypes.string,
    visit_duration: PropTypes.number.isRequired,
    page_views: PropTypes.number.isRequired,
  })),
};

export default injectIntl(LeadScoringVisitsTest);



// WEBPACK FOOTER //
// ./src/components/LeadScoring/LeadScoringVisitsTest/index.js